/**
 * The Docker image cache of the person's own sandbox (vfs-service src/routes/dockerCache.routes.js, forwarded to the
 * runner): a plan with Docker and a "Docker image cache" size keeps pulled and built images across sleeps, up to that
 * size, removing the least recently used ones that nobody keeps.
 * - `getDockerCache()` -> `{ available, enabled, docker, limitBytes, usedBytes, images: [{ id, tags, bytes, createdMs,
 *   lastUsedMs, inUse, keep }] }`, `{ available: false, reason }`, or null (vfs-service too old / not configured);
 * - `keepImage(id, keep)`, `removeImage(id)`.
 */
import config from '../config';
import { getAuthorizedFetch } from '../utils/fetchRegistry';

const base = () => (config.vfsServiceUrl || '').replace(/\/$/, '');
const PATH = '/api/v1/me/docker-cache';

async function call(path, init, what) {
  if (!base()) { return null; }
  const response = await getAuthorizedFetch()(`${base()}${PATH}${path}`, { ...init, headers: { Accept: 'application/json', 'Content-Type': 'application/json' } });
  if (response.status === 404 && !path) { return null; }
  const data = await response.json().catch(() => null);
  if (!response.ok) { throw new Error(data?.error || `${what} failed (${response.status})`); }
  return data;
}

export const getDockerCache = () => call('', { method: 'GET' }, 'Docker image cache');
export const keepImage = (id, keep) => call(`/images/${encodeURIComponent(id)}/keep`, { method: 'POST', body: JSON.stringify({ keep }) }, 'Keep');
export const removeImage = (id) => call(`/images/${encodeURIComponent(id)}`, { method: 'DELETE' }, 'Remove');
